import React from 'react';
import ProductSection from '../components/home/ProductSection';
import PreorderBanner from '../components/home/PreorderBanner';

const Shop = () => {
  return (
    <main className="min-h-screen bg-frost-vanilla pt-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12">
        <h1 className="text-4xl md:text-5xl font-bold text-center mb-4">All Products</h1>
        <p className="text-center text-gray-600 max-w-2xl mx-auto">
          Browse our complete selection of flavor flights, gift boxes, and party bundles. 
          Order by Wednesday to make the next shipping batch.
        </p>
      </div>
      <PreorderBanner />
      <ProductSection />
    </main>
  );
};

export default Shop;